import { css } from 'emotion';

const styles = {
	dateWrapperVMStyle: css`
		.vm .web-ui-components .chaps & {
			min-width: 8rem;
		}
	`,
};

export default styles;
